import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';

@Component({
  selector: 'sibat-toggle-button',
  template: `
    <mat-slide-toggle
      class="toggle"
      data-testid="the-toggle"
      [disabled]="disabled"
      [checked]="checked"
      (change)="toggleChanged.emit($event.checked)"
    >
      <span>{{ label }}</span>
    </mat-slide-toggle>
  `,
  styleUrls: ['buttons.scss'],
  imports: [MatSlideToggle],
})
export class ToggleButtonComponent {
  @Input() label: string;
  @Input() disabled = false;
  @Input() checked = false;
  @Input() formControlName: string;
  @Output() toggleChanged = new EventEmitter<boolean>();

  constructor() {}
}
